import { Box } from "@mui/material";
import React from "react";
import { TkConfimItemProps } from "../../../type/componentsType/TkConfimItem";
import TkButton from "../../atoms/TkButton";
import { TkRadioGroup } from "../../atoms/TkRadioGroup";
import TkCheckbox from "../../atoms/TkCheckbox";
import "./_style.scss";
import TkHelpIcon from "../../atoms/TkHelpIcon";

/**
 * 確認アイテムコンポーネントを表します。
 * @param {TkConfimItemProps} props - TkConfirmItemコンポーネントのプロパティ。
 * @returns {React.FC} TkConfirmItemコンポーネント。
 */
const TkConfirmItem: React.FC<TkConfimItemProps> = (props) => {
  const {
    children,
    confimButtonContext,
    isShowConfimButton = true,
    onConfimButtonClicked,
    onFunctionButtonClicked,
    functionButtonContext,
    isShowFunctionButton = false,
    useCheckBox,
    checkboxContext,
    onChange,
    radioPropsList,
    helpIcon,
    helpText,
    isGuideText,
    guideText,
    checked,
    disabled,
  } = props;

  const handleComfimButtonClick = () => {
    onConfimButtonClicked && onConfimButtonClicked();
  };

  const handleChange = (event: any) => {
    onChange && onChange(event);
  };

  const handleFunctionButtonClick = () => {
    onFunctionButtonClicked && onFunctionButtonClicked();
  };

  return (
    <Box className="TkConfirmItem">
      <Box className="lineBox">
        <Box className="textContext item">
          {children}
          {helpIcon && <TkHelpIcon helpMessage={helpText} />}
        </Box>

        <Box className="item">
          {isShowConfimButton && confimButtonContext?.trim() && (
            <TkButton onClick={handleComfimButtonClick}>
              {confimButtonContext}
            </TkButton>
          )}
        </Box>
      </Box>

      <Box className="lineBox">
        <Box className="item">
          {useCheckBox ? (
            <TkCheckbox
              checked={checked ?? false}
              onChange={(e: any) => handleChange(e.target.checked)}
              label={checkboxContext}
            />
          ) : (
            <TkRadioGroup
              onGetValue={handleChange}
              radioPropsList={radioPropsList ?? []}
              wantToSetValue={checked ?? ""}
              disabled={disabled}
            />
          )}
          <Box className="guideText">{isGuideText && guideText}</Box>
        </Box>

        <Box className="item">
          {isShowFunctionButton && functionButtonContext?.trim() && (
            <TkButton onClick={handleFunctionButtonClick}>
              {functionButtonContext}
            </TkButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default TkConfirmItem;
